import type {
  AgeVerificationMethodType,
  AvailableMethodsResponse,
  HiddenAgeVerificationResponse,
  InitAsyncVerificationPayload,
  InitAsyncVerificationResponse,
  VerifyResponse,
  VerifyVariables,
} from "@jti/fe-common";
import type { AvpContract } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class AvpAPILegacy extends Rest implements AvpContract {
  readonly name = "AvpAPI";
  constructor(
    baseUrl: string,
    tenantToken: string,
    private isoCountryCode: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", tenantToken);
  }

  async getAvailableMethods(): Promise<AvailableMethodsResponse> {
    const { statusCode, data } = await this.request<AgeVerificationMethodType[]>(
      `/available-methods/${this.isoCountryCode}`,
      {
        method: "GET",
      }
    );
    return Promise.resolve({
      data,
      statusCode,
    });
  }

  async isAgeVerificationHidden(): Promise<boolean> {
    const { has_hidden_verification } = await this.request<HiddenAgeVerificationResponse>("/has-hidden-verification", {
      method: "GET",
    });
    return has_hidden_verification;
  }

  async verify(variables: VerifyVariables): Promise<VerifyResponse> {
    return this.request<VerifyResponse>(
      "/verify",
      {
        method: "POST",
        // TODO: Need to fix proper types to normally pass this variable
        body: JSON.stringify({
          ...variables,
          ...(variables.fields && {
            fields: {
              ...variables.fields,
              ...(variables.fields.workflowName && { workflow_name: variables.fields.workflowName }),
              ...(variables.fields.workflowDefinitionId && {
                workflow_definition_id: variables.fields.workflowDefinitionId,
              }),
              user_email: variables.fields.userEmail ?? variables.user_email,
            },
          }),
        }),
      },
      true
    );
  }

  async initAsyncVerification(payload: InitAsyncVerificationPayload): Promise<InitAsyncVerificationResponse> {
    return this.request<InitAsyncVerificationResponse>(
      "/init-async-verification",
      {
        method: "POST",
        body: JSON.stringify({
          user_email: payload.userEmail,
          method_code: payload.methodCode,
          country_code: this.isoCountryCode,
          ...(payload.fields && {
            fields: {
              callback: payload.fields.callback,
              firstName: payload.fields.firstName,
              lastName: payload.fields.lastName,
              dateOfBirth: payload.fields.dateOfBirth,
              workflow_name: payload.fields.workflowName,
              workflow_definition_id: payload.fields.workflowDefinitionId,
              identity_verification_id: payload.fields.identity_verification_id,
              userEmail: payload.userEmail,
            },
          }),
        }),
      },
      true
    );
  }
}
